import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosPerfilMixin = {
  computed: {
    permisosPerfil() {
      return {
        accesoModulo: tienePermiso('Profile'),
        modificarPerfil: tienePermiso('ModifyProfile'),
      };
    },
  },
};
